import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getAppInsights } from "../appInsights";

export function useAppInsightsPageTracking(): void {
  const location = useLocation();

  useEffect(() => {
    getAppInsights().trackPageView({
      uri: location.pathname,
    });
  }, [location]);
}
